export default __webpack_public_path__ + "static/media/house.8a77f6c0.svg";